/* Banana Research pixel peeper. Compare any two Prizm lenses on the same scene.
   Desktop: two panes side by side, zoom and pan locked together.
   Mobile: the two lenses overlaid with a horizontal reveal slider.
   Generated skeleton by research/build-peeper.py; this behaviour file is hand kept. */
(function () {
  "use strict";
  var root = document.getElementById('lpeep');
  if (!root) return;
  var DATA = JSON.parse(document.getElementById('lpeep-data').textContent);
  var ASSETS = {};
  var aEl = document.getElementById('lpeep-assets');
  if (aEl) { try { ASSETS = JSON.parse(aEl.textContent); } catch (e) {} }
  var BASE = root.getAttribute('data-base') || '';

  var SCENES = DATA.scenes, LENSES = DATA.lenses;
  var BYSLUG = {}; LENSES.forEach(function (l) { BYSLUG[l.slug] = l; });

  /* Host pages preselect a pair via {% render 'pixel-peeper', lenses: 'a,b' %}.
     An unknown slug falls back to the default rather than rendering a blank pane. */
  function wanted(attr, fallback) {
    var v = (root.getAttribute(attr) || '').trim();
    return BYSLUG[v] ? v : fallback;
  }

  var PRO = root.getAttribute('data-pro') === '1';
  var FULL_URL = root.getAttribute('data-full') || '';

  /* Shareable state lives in the URL hash: #s=4&m=adapted&a=trail&b=road&z=2.5&x=12&y=-40.
     The hash survives Shopify's page cache untouched and adds no crawlable URL
     variants. The pro page reads and writes it; embedded peepers read it and
     keep their full-screen link pointing at the pro page with the current state. */
  function parseHash() {
    var o = {};
    location.hash.replace(/^#/, '').split('&').forEach(function (kv) {
      var p = kv.split('=');
      if (p[0]) o[p[0]] = decodeURIComponent(p[1] || '');
    });
    return o;
  }

  var st = {
    scene: SCENES[0].id,
    mode: 'adapted',
    a: wanted('data-a', 'no-lens'),
    b: wanted('data-b', DATA.defaultB || 'trail'),
    view: 'auto',                     // 'auto' | 'side' | 'overlay'
    zoom: 1, ox: 0, oy: 0,           // desktop shared transform
    slider: 50                        // mobile reveal %
  };

  /* Hash keys are verbose (scene by slug, left/right, mode, zoom, view);
     the original terse keys are still read so early shared links survive. */
  function sceneBySlugOrId(v) {
    for (var i = 0; i < SCENES.length; i++) {
      if (SCENES[i].slug === v || String(SCENES[i].id) === v) return SCENES[i].id;
    }
    return null;
  }
  function sceneSlug(id) {
    for (var i = 0; i < SCENES.length; i++) if (SCENES[i].id === id) return SCENES[i].slug;
    return id;
  }

  var H = parseHash(), pendingView = null;
  var hA = H.left || H.a, hB = H.right || H.b;
  if (hA && BYSLUG[hA]) st.a = hA;
  if (hB && BYSLUG[hB]) st.b = hB;
  var hsc = sceneBySlugOrId(H.scene || H.s || '');
  if (hsc !== null) st.scene = hsc;
  var hm = H.mode || H.m;
  if (['adapted', 'linear', 'coloronly'].indexOf(hm) > -1) st.mode = hm;
  var hv = H.view || H.v;
  if (hv === 'side' || hv === 'overlay') st.view = hv;
  var hz = parseFloat(H.zoom || H.z);
  if (hz > 1 && hz <= 8) {
    pendingView = { z: hz, x: parseInt(H.x, 10) || 0, y: parseInt(H.y, 10) || 0 };
  }

  function stateHash() {
    var s = 'scene=' + sceneSlug(st.scene) + '&mode=' + st.mode +
            '&left=' + st.a + '&right=' + st.b;
    if (st.view !== 'auto') s += '&view=' + st.view;
    if (st.zoom > 1.01) {
      s += '&zoom=' + st.zoom.toFixed(2) + '&x=' + Math.round(st.ox) + '&y=' + Math.round(st.oy);
    }
    return s;
  }
  var stateTimer = null;
  function scheduleState() {
    clearTimeout(stateTimer);
    stateTimer = setTimeout(function () {
      var h = stateHash();
      if (PRO) history.replaceState(null, '', '#' + h);
      var full = root.querySelector('#lp-full');
      if (full && FULL_URL) full.href = FULL_URL + '#' + h;
    }, 250);
  }

  function key(lens, tier) { return 's' + st.scene + '-' + lens + '-' + st.mode + '-' + tier; }
  function url(lens, tier) {
    var k = key(lens, tier);
    return ASSETS[k] || (BASE + 'lens-peep-' + k + '.webp');
  }

  var isDesktop = window.matchMedia('(min-width: 820px)');
  /* 'auto' follows the breakpoint; the toggle near the zoom buttons pins
     side-by-side or the overlay slider explicitly, on any screen. */
  function viewMode() {
    return st.view !== 'auto' ? st.view : (isDesktop.matches ? 'side' : 'overlay');
  }

  /* ---------- build controls ---------- */
  var elScene = root.querySelector('#lp-scene');
  var elMode = root.querySelector('#lp-mode');
  var elA = root.querySelector('#lp-a');
  var elB = root.querySelector('#lp-b');
  var elStage = root.querySelector('#lp-stage');

  /* Scene selector: a strip of real thumbnails inside the console. The no lens
     frame is the scene as the eye saw it, so it is the honest teaser. */
  function sceneThumb(sid) {
    var k = 's' + sid + '-no-lens-adapted-thumb';
    return ASSETS[k] || (BASE + 'lens-peep-' + k + '.webp');
  }
  SCENES.forEach(function (s) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'lp-th';
    b.setAttribute('data-scene', s.id);
    if (s.light) b.title = s.light;
    var im = document.createElement('img');
    im.src = sceneThumb(s.id); im.alt = s.title; im.loading = 'lazy'; im.draggable = false;
    var cap = document.createElement('span');
    cap.className = 'lp-th-t'; cap.textContent = s.title;
    b.appendChild(im); b.appendChild(cap);
    b.onclick = function () { st.scene = s.id; resetView(); syncControls(); rebuild(); };
    elScene.appendChild(b);
  });

  [['adapted', DATA.i18n.adapted], ['linear', DATA.i18n.linear], ['coloronly', DATA.i18n.coloronly]]
    .forEach(function (m) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'lp-seg'; b.textContent = m[1];
      b.setAttribute('data-mode', m[0]);
      b.title = DATA.i18n[m[0] + 'Hint'] || '';
      b.onclick = function () { st.mode = m[0]; syncControls(); refreshImages(); };
      elMode.appendChild(b);
    });

  /* ---------- visual lens picker ----------
     The two compare controls show the lens identity itself: a split chip,
     tint swatch lower-left, exterior mirror upper-right. Clicking opens a
     grid of every lens over the stage. */
  function identUrl(kind, slug) {
    var k = 'ident-' + kind + '-' + slug;
    return ASSETS[k] || (BASE + 'lens-ref-' + kind + '-' + slug + '.webp');
  }
  function chipHtml(slug) {
    if (slug === 'no-lens') return '<span class="lp-chipimg lp-chip-none"></span>';
    return '<span class="lp-chipimg">' +
      '<img src="' + identUrl('ext', slug) + '" alt="" loading="lazy">' +
      '</span>';
  }
  function renderLensBtn(el, slug) {
    var l = BYSLUG[slug];
    el.innerHTML = chipHtml(slug) +
      '<span class="lp-lname">' + l.name + (l.fake ? ' \u26a0' : '') + '</span>';
  }
  /* ---------- permanent lens bar ----------
     Always visible under the stage. The two compare buttons arm a side
     (right by default); a strip click assigns the lens to the armed side.
     Clicking the lens already on the other side swaps the pair. Frames:
     left selection white, right selection banana yellow, matching each
     button's underline. */
  var elBar = root.querySelector('#lp-lensbar');
  if (elBar) {
    LENSES.forEach(function (l) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'lp-pcell';
      b.setAttribute('data-slug', l.slug);
      var imgHtml = l.slug === 'no-lens'
        ? '<span class="lp-pc-im lp-pc-none"></span>'
        : '<span class="lp-pc-im"><img src="' + identUrl('ext', l.slug) +
          '" alt="" loading="lazy" draggable="false"></span>';
      b.innerHTML = imgHtml +
        '<span class="lp-pc-t">' + l.name + (l.fake ? ' \u26a0' : '') + '</span>';
      b.onclick = function () { openSideAsk(b, l.slug); };
      elBar.appendChild(b);
    });
  }
  function syncBar() {
    if (!elBar) return;
    elBar.querySelectorAll('.lp-pcell').forEach(function (c) {
      var slug = c.getAttribute('data-slug');
      c.classList.toggle('sel-a', slug === st.a);
      c.classList.toggle('sel-b', slug === st.b);
    });
  }
  /* clicking a bar lens asks which side it should take */
  var sideAsk = null, askSlug = null;
  function closeSideAsk() {
    if (sideAsk) sideAsk.classList.remove('on');
    document.removeEventListener('keydown', askKey);
  }
  function askKey(e) { if (e.key === 'Escape') closeSideAsk(); }
  function assignSide(side) {
    var other = side === 'a' ? 'b' : 'a';
    if (st[other] === askSlug) {
      st[other] = st[side];               // the pair swaps rather than duplicating
    }
    st[side] = askSlug;
    closeSideAsk(); syncControls(); refreshImages();
  }
  function openSideAsk(cell, slug) {
    askSlug = slug;
    var console_ = root.querySelector('.lp-console');
    if (!sideAsk) {
      sideAsk = document.createElement('div');
      sideAsk.className = 'lp-sideask';
      sideAsk.innerHTML =
        '<button type="button" class="lp-ask-a">&#8592; ' + DATA.i18n.sideLeft + '</button>' +
        '<button type="button" class="lp-ask-b">' + DATA.i18n.sideRight + ' &#8594;</button>';
      console_.appendChild(sideAsk);
      sideAsk.querySelector('.lp-ask-a').onclick = function () { assignSide('a'); };
      sideAsk.querySelector('.lp-ask-b').onclick = function () { assignSide('b'); };
      document.addEventListener('pointerdown', function (e) {
        if (sideAsk.classList.contains('on') &&
            !sideAsk.contains(e.target) && !e.target.closest('.lp-pcell')) closeSideAsk();
      });
      if (elBar) elBar.addEventListener('scroll', closeSideAsk);
    }
    var cr = cell.getBoundingClientRect(), kr = console_.getBoundingClientRect();
    sideAsk.classList.add('on');
    var w = sideAsk.offsetWidth;
    var x = cr.left - kr.left + cr.width / 2 - w / 2;
    x = Math.max(8, Math.min(kr.width - w - 8, x));
    sideAsk.style.left = x + 'px';
    sideAsk.style.top = (cr.top - kr.top - sideAsk.offsetHeight - 8) + 'px';
    document.addEventListener('keydown', askKey);
  }
  /* the compare buttons scroll the bar to their side's lens */
  function revealInBar(slug) {
    if (!elBar) return;
    var c = elBar.querySelector('[data-slug="' + slug + '"]');
    if (c && c.scrollIntoView) c.scrollIntoView({ inline: 'center', block: 'nearest' });
  }
  elA.onclick = function () { revealInBar(st.a); };
  elB.onclick = function () { revealInBar(st.b); };

  function syncControls() {
    root.querySelectorAll('.lp-th').forEach(function (b) {
      b.classList.toggle('on', b.getAttribute('data-scene') === String(st.scene));
    });
    root.querySelectorAll('.lp-seg').forEach(function (b) {
      b.classList.toggle('on', b.getAttribute('data-mode') === st.mode);
    });
    renderLensBtn(elA, st.a); renderLensBtn(elB, st.b);
    syncBar();
  }

  /* ---------- loading spinner (scenes/zoom images are large) ---------- */
  function addSpinner() {
    if (elStage.querySelector('.lp-spinner')) return;
    var s = document.createElement('div'); s.className = 'lp-spinner';
    s.setAttribute('aria-hidden', 'true'); elStage.appendChild(s);
  }
  function trackLoad(imgs) {
    imgs = Array.prototype.slice.call(imgs);
    var pending = imgs.length;
    if (!pending) { elStage.classList.remove('loading'); return; }
    elStage.classList.add('loading');
    function done() { if (--pending <= 0) elStage.classList.remove('loading'); }
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) { done(); return; }
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }

  /* ================= DESKTOP: two panes, synced zoom/pan ================= */
  function buildSide() {
    elStage.className = 'lp-stage lp-side';
    elStage.innerHTML = '';
    /* No per-pane name tags: the compare selects overlaid above are the label. */
    ['a', 'b'].forEach(function (slot) {
      var pane = document.createElement('div'); pane.className = 'lp-pane'; pane.setAttribute('data-slot', slot);
      var img = document.createElement('img'); img.className = 'lp-img'; img.alt = '';
      img.draggable = false; img.src = url(st[slot], 'zoom');
      pane.appendChild(img); elStage.appendChild(pane);
    });
    addSpinner();
    trackLoad(elStage.querySelectorAll('.lp-img'));
    applyTransform();
    wireZoomPan();
    var hint = document.createElement('div'); hint.className = 'lp-hint';
    hint.textContent = DATA.i18n.zoomHint; elStage.appendChild(hint);
    addViewCtl();
    /* Google Maps style zoom buttons, top right: the visible cue that the
       panes zoom at all. Steps around the stage centre; wheel still zooms
       to the cursor. */
    var zc = document.createElement('div'); zc.className = 'lp-zoomctl';
    [['+', 1.5], ['−', 1 / 1.5]].forEach(function (z) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = z[0];
      b.setAttribute('aria-label', z[1] > 1 ? 'Zoom in' : 'Zoom out');
      b.onclick = function () { zoomBy(z[1]); };
      zc.appendChild(b);
    });
    elStage.appendChild(zc);
  }
  function zoomBy(f) {
    var pane = elStage.querySelector('.lp-pane');
    if (!pane) return;
    var prev = st.zoom;
    var nz = Math.max(1, Math.min(8, st.zoom * f));
    st.ox = st.ox * (nz / prev);
    st.oy = st.oy * (nz / prev);
    st.zoom = nz; clampPan(pane); applyTransform();
  }
  function applyTransform() {
    elStage.querySelectorAll('.lp-img, .lp-ov').forEach(function (img) {
      img.style.transform = 'translate(' + st.ox + 'px,' + st.oy + 'px) scale(' + st.zoom + ')';
    });
    scheduleState();
  }
  function clampPan(pane) {
    var w = pane.clientWidth, h = pane.clientHeight;
    var mx = (st.zoom - 1) * w / 2, my = (st.zoom - 1) * h / 2;
    st.ox = Math.max(-mx, Math.min(mx, st.ox));
    st.oy = Math.max(-my, Math.min(my, st.oy));
  }
  function wireZoomPan() {
    var pane = elStage.querySelector('.lp-pane');
    elStage.querySelectorAll('.lp-pane').forEach(function (p) {
      p.addEventListener('wheel', function (e) {
        e.preventDefault();
        var r = p.getBoundingClientRect();
        var cx = e.clientX - r.left - r.width / 2;
        var cy = e.clientY - r.top - r.height / 2;
        var prev = st.zoom;
        var nz = Math.max(1, Math.min(8, st.zoom * (e.deltaY < 0 ? 1.15 : 1 / 1.15)));
        // keep cursor point stable
        st.ox = (st.ox - cx) * (nz / prev) + cx;
        st.oy = (st.oy - cy) * (nz / prev) + cy;
        st.zoom = nz; clampPan(p); applyTransform();
      }, { passive: false });
      var drag = null;
      p.addEventListener('pointerdown', function (e) {
        drag = { x: e.clientX, y: e.clientY, ox: st.ox, oy: st.oy };
        try { p.setPointerCapture(e.pointerId); } catch (err) {}
      });
      p.addEventListener('pointermove', function (e) {
        if (!drag) return;
        st.ox = drag.ox + (e.clientX - drag.x); st.oy = drag.oy + (e.clientY - drag.y);
        clampPan(p); applyTransform();
      });
      p.addEventListener('pointerup', function () { drag = null; });
      p.addEventListener('pointercancel', function () { drag = null; });
      p.addEventListener('dblclick', function () { resetView(); applyTransform(); });
    });
  }

  /* ================= MOBILE: overlay + horizontal reveal ================= */
  function buildOverlay() {
    elStage.className = 'lp-stage lp-overlay';
    elStage.innerHTML =
      '<div class="lp-ov-wrap">' +
        '<img class="lp-ov lp-ov-b" alt="" draggable="false">' +
        '<div class="lp-ov-clip"><img class="lp-ov lp-ov-a" alt="" draggable="false"></div>' +
        '<div class="lp-divider"><span class="lp-knob"></span></div>' +
      '</div>';
    addSpinner();
    refreshImages();
    addViewCtl();
    var wrap = elStage.querySelector('.lp-ov-wrap');
    /* the clipped image must match the wrap, not the viewport, so the
       overlay also works inside a desktop-width container */
    function sizeClip() {
      var w = wrap.clientWidth;
      elStage.querySelectorAll('.lp-ov-clip .lp-ov').forEach(function (i) {
        i.style.width = w + 'px'; i.style.maxWidth = 'none';
      });
    }
    sizeClip();
    window.addEventListener('resize', function () {
      if (viewMode() === 'overlay' && document.contains(wrap)) sizeClip();
    });
    var hint = document.createElement('div'); hint.className = 'lp-hint';
    hint.textContent = DATA.i18n.ovHint; elStage.appendChild(hint);
    var clip = elStage.querySelector('.lp-ov-clip');
    var divider = elStage.querySelector('.lp-divider');
    function setPct(px) {
      var r = wrap.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, ((px - r.left) / r.width) * 100));
      st.slider = pct;
      clip.style.width = pct + '%';
      divider.style.left = pct + '%';
    }
    st.slider = 50; clip.style.width = '50%'; divider.style.left = '50%';

    /* One finger drives the reveal slider. Two fingers pinch zoom and pan,
       both layers moving in lockstep so the divider keeps working while
       zoomed. Trackpads pinch via ctrl+wheel. Double tap resets. */
    var pts = {}, pinch = null, active = false, lastTap = 0;
    function count() { return Object.keys(pts).length; }
    function mid() {
      var ids = Object.keys(pts), r = wrap.getBoundingClientRect();
      return {
        x: (pts[ids[0]].x + pts[ids[1]].x) / 2 - r.left - r.width / 2,
        y: (pts[ids[0]].y + pts[ids[1]].y) / 2 - r.top - r.height / 2
      };
    }
    function dist() {
      var ids = Object.keys(pts);
      return Math.hypot(pts[ids[0]].x - pts[ids[1]].x, pts[ids[0]].y - pts[ids[1]].y);
    }
    wrap.addEventListener('pointerdown', function (e) {
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
      if (count() === 2) {
        active = false; lastTap = 0;
        pinch = { d0: dist(), z0: st.zoom, m0: mid(), ox0: st.ox, oy0: st.oy };
      } else if (count() === 1) {
        var now = Date.now();
        if (now - lastTap < 320 && st.zoom > 1) {
          resetView(); applyTransform(); lastTap = 0; return;
        }
        lastTap = now;
        active = true; setPct(e.clientX);
      }
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) { if (active) setPct(e.clientX); return; }
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (pinch && count() === 2) {
        var nz = Math.max(1, Math.min(8, pinch.z0 * dist() / pinch.d0));
        var m = mid();
        st.ox = (pinch.ox0 - pinch.m0.x) * (nz / pinch.z0) + pinch.m0.x + (m.x - pinch.m0.x);
        st.oy = (pinch.oy0 - pinch.m0.y) * (nz / pinch.z0) + pinch.m0.y + (m.y - pinch.m0.y);
        st.zoom = nz; clampPan(wrap); applyTransform();
      } else if (active) {
        setPct(e.clientX);
      }
    });
    function lift(e) {
      delete pts[e.pointerId];
      if (count() < 2) pinch = null;
      if (count() === 0) active = false;
    }
    wrap.addEventListener('pointerup', lift);
    wrap.addEventListener('pointercancel', lift);
    wrap.addEventListener('wheel', function (e) {
      if (!e.ctrlKey) return;              // trackpad pinch arrives as ctrl+wheel
      e.preventDefault();
      var r = wrap.getBoundingClientRect();
      var cx = e.clientX - r.left - r.width / 2;
      var cy = e.clientY - r.top - r.height / 2;
      var prev = st.zoom;
      var nz = Math.max(1, Math.min(8, st.zoom * (e.deltaY < 0 ? 1.12 : 1 / 1.12)));
      st.ox = (st.ox - cx) * (nz / prev) + cx;
      st.oy = (st.oy - cy) * (nz / prev) + cy;
      st.zoom = nz; clampPan(wrap); applyTransform();
    }, { passive: false });
    wrap.addEventListener('dblclick', function () { resetView(); applyTransform(); });
  }

  /* view toggle: side by side or overlay slider, on any screen */
  function addViewCtl() {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'lp-viewctl';
    var toOverlay = viewMode() === 'side';
    b.innerHTML = toOverlay
      ? '<svg width="16" height="14" viewBox="0 0 16 14"><rect x="0.5" y="0.5" width="15" height="13" rx="1.5" fill="none" stroke="currentColor"/><line x1="8" y1="0.5" x2="8" y2="13.5" stroke="currentColor"/><circle cx="8" cy="7" r="2.3" fill="currentColor"/></svg>'
      : '<svg width="16" height="14" viewBox="0 0 16 14"><rect x="0.5" y="0.5" width="6.6" height="13" rx="1" fill="none" stroke="currentColor"/><rect x="8.9" y="0.5" width="6.6" height="13" rx="1" fill="none" stroke="currentColor"/></svg>';
    b.title = toOverlay ? DATA.i18n.viewOverlay : DATA.i18n.viewSide;
    b.setAttribute('aria-label', b.title);
    b.onclick = function () {
      st.view = viewMode() === 'side' ? 'overlay' : 'side';
      rebuild();
    };
    elStage.appendChild(b);
  }

  /* ---------- refresh image sources without rebuilding DOM ---------- */
  function refreshImages() {
    if (viewMode() === 'side') {
      var panes = elStage.querySelectorAll('.lp-pane');
      if (panes.length === 2) {
        panes[0].querySelector('.lp-img').src = url(st.a, 'zoom');
        panes[1].querySelector('.lp-img').src = url(st.b, 'zoom');
      }
    } else {
      var ia = elStage.querySelector('.lp-ov-a'), ib = elStage.querySelector('.lp-ov-b');
      if (ia && ib) {
        ia.src = url(st.a, 'zoom'); ib.src = url(st.b, 'zoom');
      }
    }
    trackLoad(elStage.querySelectorAll('.lp-img, .lp-ov'));
    scheduleState();
  }

  function resetView() { st.zoom = 1; st.ox = 0; st.oy = 0; }

  function rebuild() {
    resetView();
    var side = viewMode() === 'side';
    root.classList.toggle('view-side', side);
    root.classList.toggle('view-overlay', !side);
    if (side) buildSide(); else buildOverlay();
    scheduleState();
  }

  isDesktop.addEventListener ? isDesktop.addEventListener('change', rebuild)
                             : isDesktop.addListener(rebuild);

  /* Host pages can offer preset pairs: any element carrying
     data-lp-pair="a,b" loads that pair and brings the console into view;
     data-lp-scene="N" additionally switches to that scene, so the peeper
     reproduces exactly the comparison the reader clicked, not just the
     lenses. The lens review page's Popular comparisons gallery uses this. */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-lp-pair]') : null;
    if (!el) return;
    var p = (el.getAttribute('data-lp-pair') || '').split(',');
    if (p.length !== 2) return;
    var a = p[0].trim(), b = p[1].trim();
    if (!BYSLUG[a] || !BYSLUG[b]) return;
    st.a = a; st.b = b;
    var sc = parseInt(el.getAttribute('data-lp-scene') || '', 10);
    var known = SCENES.some(function (s) { return s.id === sc; });
    if (known && sc !== st.scene) {
      st.scene = sc; resetView(); syncControls(); rebuild();
    } else {
      syncControls(); refreshImages();
    }
    (root.querySelector('.lp-console') || root).scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- "how brightness works" dialog ---------- */
  var elHelp = root.querySelector('#lp-help'), helpEl = null;
  function helpKey(e) { if (e.key === 'Escape') closeHelp(); }
  function closeHelp() {
    helpEl.classList.remove('on');
    document.removeEventListener('keydown', helpKey);
  }
  function openHelp() {
    if (!helpEl) {
      var i = DATA.i18n, m = root.getAttribute('data-method') || '';
      helpEl = document.createElement('div');
      helpEl.className = 'lp-dialog';
      helpEl.innerHTML =
        '<div class="lp-dlg-box" role="dialog" aria-modal="true" aria-label="' + i.helpLabel + '">' +
        '<button class="lp-dlg-close" type="button" aria-label="Close">&times;</button>' +
        '<h3>' + i.helpLabel + '</h3><p>' + i.helpIntro + '</p>' +
        '<h4>' + i.adapted + '</h4><p>' + i.helpAdaptedB + '</p>' +
        '<h4>' + i.linear + '</h4><p>' + i.helpLinearB + '</p>' +
        '<h4>' + i.coloronly + '</h4><p>' + i.helpColorB + '</p>' +
        (m ? '<p class="lp-dlg-more"><a href="' + m + '">' + i.helpMethod + ' &#8594;</a></p>' : '') +
        '</div>';
      document.body.appendChild(helpEl);
      helpEl.addEventListener('click', function (e) { if (e.target === helpEl) closeHelp(); });
      helpEl.querySelector('.lp-dlg-close').onclick = closeHelp;
    }
    helpEl.classList.add('on');
    document.addEventListener('keydown', helpKey);
    helpEl.querySelector('.lp-dlg-close').focus();
  }
  if (elHelp) elHelp.onclick = openHelp;

  /* pro page: share the exact current view */
  var elShare = root.querySelector('#lp-share');
  if (elShare) {
    var shareIdle = elShare.textContent;
    elShare.onclick = function () {
      var url = location.href.split('#')[0] + '#' + stateHash();
      history.replaceState(null, '', url);
      var done = function () {
        elShare.textContent = elShare.getAttribute('data-copied') || 'Link copied';
        setTimeout(function () { elShare.textContent = shareIdle; }, 1600);
      };
      function legacyCopy() {
        var ta = document.createElement('textarea');
        ta.value = url; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(ta);
      }
      if (navigator.share) {
        navigator.share({ url: url }).catch(function () {});
        done();
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, legacyCopy);
      } else {
        legacyCopy();
      }
    };
  }

  syncControls();
  rebuild();
  var selB = elBar && elBar.querySelector('.sel-b');
  if (selB && selB.scrollIntoView) selB.scrollIntoView({ inline: 'center', block: 'nearest' });

  /* restore a deep-linked zoom and pan once the panes exist (desktop mode) */
  if (pendingView) {
    st.zoom = pendingView.z; st.ox = pendingView.x; st.oy = pendingView.y;
    var host0 = elStage.querySelector('.lp-pane') || elStage.querySelector('.lp-ov-wrap');
    if (host0) { clampPan(host0); applyTransform(); }
  }
})();
